export const TEXT_CLAMPING_LINES_COUNT = 3
